import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/tipoExame`;


export default class TipoExameService{
	static async listar() {
		return axios.get(URL_BASE + "/listar");
	}
}



// WEBPACK FOOTER //
// ./src/service/TipoExameService.js